import React, { useEffect, useState } from 'react'
import { isIstioInstalled } from '../../../functions'
import './istio.css'

function KubernetesConfigurationsIstio({ connectorId }) {

    const [istioInstalled, setIstioInstalled] = useState(false)

    useEffect(()=>{
        isIstioInstalled(`cluster-${connectorId}`, setIstioInstalled);
    }, [])

    return (
        <div className='istio'>

           {!istioInstalled && <div className='istio-noninstall'>
                <label>istio is not installed in this cluster</label>
                <button className='install-istio'>Install Istio</button>
            </div>}

            {
                istioInstalled && <div className='istio-mgmt'>
                
            </div>
            }
            
            
        </div>
    )
}

export default KubernetesConfigurationsIstio